import React, { useState } from 'react'
import { Button } from '~/components/_atoms'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'

const RoundtableRegistrationModal = ({
  variant = 'default',
  color,
  size,
  className = '',
  link,
  name,
  op_classic = false,
}) => {
  const [open, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen(!open)
  }

  return (
    <Dialog open={open} onOpenChange={toggleOpen} className="rounded-2xl">
      <DialogTrigger asChild className="cursor-pointer">
        {op_classic ? (
          <button className="text-link hover:text-link-hover">Register</button>
        ) : (
          <Button
            variant={variant}
            color={color}
            size={size}
            className={className}
          >
            Register Now
          </Button>
        )}
      </DialogTrigger>

      <DialogContent
        className="fix-legacy-hack font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">Register for Networking Roundtable</h2>
          </DialogTitle>
        </DialogHeader>

        <div className="px-4 pb-4">
          <div className="mb-4">
            <p className="text-sm text-gray-700">
              As part of your registration for {name}, we require your
              acknowledgment of the following:
            </p>
            <p className="!font-bold">Confidentiality Agreement</p>
            <p>
              {' '}
              These sessions are designed to be open, honest, and supportive
              spaces. While the session <strong>will not be recorded</strong>,
              participants may share personal experiences, job search
              challenges, or sensitive career insights. By registering, you
              agree to:
            </p>
            <ul className="mb-[0.625rem] list-disc pl-5">
              <li>
                Treat all shared information as{' '}
                <strong>strictly confidential</strong>.
              </li>
              <li>
                <strong>Not disclose</strong>, reference, or repeat anything
                shared by other participants outside the session.
              </li>
              <li>
                <strong>Respect the privacy</strong> and dignity of every
                individual in attendance.
              </li>
            </ul>
            <p className="!font-bold">Chat Summary Distribution</p>
            <p>
              A non-recorded summary of resources and links shared in the
              session chat will be distributed{' '}
              <strong>only to attendees</strong>. By registering, you consent to
              your chat contributions being included in that recap.
            </p>
            <p className="!font-bold">No Recording Policy</p>
            <p>
              Recording, photographing, or screenshotting any portion of the
              session is prohibited.
            </p>
            <p>
              <strong>By completing your registration</strong>, you confirm your
              agreement to honor the confidentiality of the session and uphold
              the respectful, professional tone we expect from all participants.
            </p>
          </div>

          <div className="flex flex-row justify-end">
            <Button variant={variant} color="primary" size="sm" href={link}>
              Complete Registration
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default RoundtableRegistrationModal
